const ShopItems = [
  {
    id: 1,
    title: "Minimal Lamp",
    price: "$42.00",
    image: "https://picsum.photos/600/800?1",
    category: "shop-all",
    link: "https://amazon.com",
  },
  {
    id: 2,
    title: "Wood Desk Organizer",
    price: "$28.00",
    image: "https://picsum.photos/600/800?2",
    category: "shop-all",
    link: "https://amazon.com",
  },
  {
    id: 3,
    title: "Ceramic Mug",
    price: "$18.00",
    image: "https://picsum.photos/600/800?3",
    category: "shop-all",
    link: "https://amazon.com",
  },
  {
    id: 4,
    title: "Wireless Keyboard",
    price: "$65.00",
    image: "https://picsum.photos/600/800?4",
    category: "shop-all",
    link: "https://amazon.com",
  },
  {
    id: 5,
    title: "Canvas Tote Bag",
    price: "$22.00",
    image: "https://picsum.photos/600/800?5",
    category: "shop-all",
    link: "https://amazon.com",
  },
  {
    id: 6,
    title: "Notebook Set",
    price: "$14.00",
    image: "https://picsum.photos/600/800?6",
    category: "shop-all",
    link: "https://amazon.com",
  },
  {
    id: 7,
    title: "Desk Plant",
    price: "$30.00",
    image: "https://picsum.photos/600/800?7",
    category: "shop-all",
    link: "https://amazon.com",
  },
  {
    id: 8,
    title: "Bluetooth Speaker",
    price: "$55.00",
    image: "https://picsum.photos/600/800?8",
    category: "shop-all",
    link: "https://amazon.com",
  },
  {
    id: 9,
    title: "Wall Clock",
    price: "$36.00",
    image: "https://picsum.photos/600/800?9",
    category: "shop-all",
    link: "https://amazon.com",
  },
  {
    id: 10,
    title: "Reading Light",
    price: "$24.00",
    image: "https://picsum.photos/600/800?10",
    category: "shop-all",
    link: "https://amazon.com",
  },
];

export default ShopItems;
